import { BrowserModule } from '@angular/platform-browser';
import { CUSTOM_ELEMENTS_SCHEMA, LOCALE_ID, NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { NavigationComponent } from './navigation/navigation.component';
import { HomeComponent } from './home/home.component';
import { SignupComponent } from './signup/signup.component';
import { SucessfulRegisterComponent } from './sucessful-register/sucessful-register.component';
import { AccessAccountComponent } from './access-account/access-account.component';
import { ConfirmPaymentsComponent } from './confirm-payments/confirm-payments.component';
import { ChitsComponent } from './chits/chits.component';
import { AuctionsComponent } from './auctions/auctions.component';
import { TransactionsComponent } from './transactions/transactions.component';
import { HeaderComponent } from './header/header.component';
import { InnerHeaderComponent } from './inner-header/inner-header.component';
import { MycurrencypipePipe } from './Pipes/mycurrencypipe.pipe';
import { CommonModule, DatePipe, HashLocationStrategy, LocationStrategy } from '@angular/common';
import { TranactionService } from './Services/Transaction/transaction.service';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { ToastrModule, ToastrService } from 'ngx-toastr';
import { CookieService } from 'ngx-cookie-service';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ValidationMessageComponent } from './validation-message/validation-message.component';
import { DateformatPipe } from './Pipes/dateformat.pipe';
import { JwtInterceptor } from './Services/Login/_helpers/jwt.interceptor';
import { ErrorInterceptor } from './Services/Login/_helpers/error.interceptor';
import { NumbersonlywithoutzeroDirective } from './Directives/numbersonlywithoutzero.directive';
import { MycurrencyFormatterDirective } from './Directives/mycurrency-formatter.directive';
import { ChitWorksComponent } from './chit-works/chit-works.component';
import { WhyUsComponent } from './why-us/why-us.component';
import { CompanyComponent } from './company/company.component';
import { JoinChitComponent } from './join-chit/join-chit.component';
import { CheckoutModule } from 'paytm-blink-checkout-angular';
import { TermsConditionsComponent } from './terms-conditions/terms-conditions.component';
import { ContactComponent } from './contact/contact.component';
import { PrivacyPolicyComponent } from './privacy-policy/privacy-policy.component';

@NgModule({
  declarations: [
    AppComponent,
    NavigationComponent,
    HomeComponent,
    SignupComponent,
    SucessfulRegisterComponent,
    AccessAccountComponent,
    ConfirmPaymentsComponent,
    ChitsComponent,
    AuctionsComponent,
    TransactionsComponent,
    HeaderComponent,
    ValidationMessageComponent,
    DateformatPipe,NumbersonlywithoutzeroDirective,
    InnerHeaderComponent,MycurrencypipePipe,
    MycurrencyFormatterDirective,
    ChitWorksComponent,
    WhyUsComponent,
    CompanyComponent,
    JoinChitComponent,
    TermsConditionsComponent,
    ContactComponent,
    PrivacyPolicyComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    CommonModule,
    CheckoutModule,

    FormsModule,
    ReactiveFormsModule,
 
   // CookieModule.forRoot() 
    HttpClientModule,
 
   // CookieModule.forRoot(),
    ToastrModule.forRoot({
      // timeOut: 1000,
      positionClass: 'toast-top-right',
      closeButton: true,
      preventDuplicates: true
    }),
  ],
  exports: [
    DateformatPipe,
    MycurrencypipePipe,
    NumbersonlywithoutzeroDirective,
    MycurrencyFormatterDirective
  ],
  providers: [DatePipe,
    { provide: LOCALE_ID, useValue: "en-IN" },
    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    { provide: ToastrService, },
    {provide: LocationStrategy, useClass: HashLocationStrategy},
    CookieService,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  bootstrap: [AppComponent]
})
export class AppModule { }
